import { Dropdown, Form } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

export const AssetSelector = ({ assets, selectedAsset, onChange, isEdit }) => (
  <Form.Field>
    <label>Select Asset</label>
    {!isEdit ? (
      <Dropdown
        fluid
        selection
        placeholder="Select Asset"
        disabled={isEdit}
        value={selectedAsset?.id || ''}
        options={assets.map(asset => ({
          key: asset.id,
          value: asset.id,
          text: asset.name,
        }))}
        onChange={onChange}
      />
    ) : (
      <div>
        <Link to={'/assets/' + selectedAsset?.id + '/view'}>
          {selectedAsset?.name}
        </Link>
      </div>
    )}
  </Form.Field>
);